import { OutgoingOrderContent, OutgoingTransactionOrder } from '@ui/src';
import { useAppSelector } from '@store';

const ProblemOutgoingOrderContentHOC = (): React.JSX.Element => {
  const {
    outgoing: { transaction },
  } = useAppSelector((state) => state.customersProblemTransactions);

  return (
    <OutgoingOrderContent
      isLoading={false}
      order={transaction as OutgoingTransactionOrder}
      paymentType={transaction?.paymentType}
      setChangedPaymentType={() => {}}
      setChangedPaymentTypeHintVisible={() => {}}
    />
  );
};

export default ProblemOutgoingOrderContentHOC;
